/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vermerkezahlungsverkehr1Inputs */

const de__field_vermerkezahlungsverkehr1 = /** @type {(inputs: _Field_Vermerkezahlungsverkehr1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermerke Zahlungsverkehr`)
};

/**

* @param {_Field_Vermerkezahlungsverkehr1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vermerkezahlungsverkehr1 = /** @type {((inputs?: _Field_Vermerkezahlungsverkehr1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vermerkezahlungsverkehr1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_vermerkezahlungsverkehr1(inputs)
});
export { _field_vermerkezahlungsverkehr1 as "_field_vermerkeZahlungsverkehr" }